import Province from '../../models/Province';
import { ApiAction, PaginatedApiState, initialPaginatedApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';

export interface ProvincesState extends PaginatedApiState {
  provinces?: Province[]
}

const Provinces = (state: ProvincesState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<ProvincesState>('PROVINCE_LIST')(state, action)
  }
}

export default Provinces
